import React, { useEffect } from "react";

import Header from "../../common/Header";
import MedicalDeviceDataGrid from "../MedicalDeviceDataGrid";

const columns = [
  { dataField: "CLST_PLAN_APRV_NO", caption: "임상시험계획 승인번호", dataType: "string" },
  { dataField: "CLNC_TEST_APRV_NO", caption: "임상시험 승인번호", dataType: "string" },
  { dataField: "APRV_YMD", caption: "승인일", dataType: "date", format: "yyyy-MM-dd", width: 120 },
  { dataField: "MNFT_IPRT_BSSH_NM", caption: "제조·수입업체", dataType: "string", width: 220 },
  { dataField: "APLY_BSSH_NM", caption: "신청업체", dataType: "string", width: 220 },
  { dataField: "PRDT_NM", caption: "제품명", dataType: "string", width: 260 },
  { dataField: "CLNC_TEST_TITLE", caption: "임상시험 제목", dataType: "string", width: 500 },
  { dataField: "MDEQ_CLSF_NO", caption: "의료기기 분류번호", dataType: "string" },
  { dataField: "MDEQ_PRDLST_SN", caption: "품목 일련번호", dataType: "string" },
  { dataField: "CLST_DIVS_NM", caption: "임상시험 구분", dataType: "string" },
  { dataField: "CLNC_TEST_DTL_NM", caption: "임상시험 상세구분", dataType: "string" },
  { dataField: "OCTR_PRMSN_YN", caption: "국외 허가 여부", dataType: "string", width: 110 },
  { dataField: "MNFT_IPRT_ZIPNO", caption: "제조·수입업체 우편번호", dataType: "string" },
  { dataField: "BRNO", caption: "사업자등록번호", dataType: "string" },
];

export default function MedicalDeviceClinicalTrials() {
  useEffect(() => {
    document.title = "의료기기 임상시험 정보";
  }, []);

  return (
    <>
      <Header title="MEDICAL DEVICE CLINICAL TRIAL INFO." menuDataSource={null} />
      <hr style={{ border: "0.5px solid #e0e0e0" }} />
      <MedicalDeviceDataGrid
        endpoint="/api/medical-device/clinical-trials"
        keyExpr="id"
        columns={columns}
        storageKey="MedicalDeviceClinicalTrials"
        exportTitle="식품의약품안전처_의료기기 임상시험 정보"
      />
    </>
  );
}
